import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Toolbar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 24px;
`;

const LeftSlot = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    min-width: 280px;
`;

const RightSlot = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

function PageToolbar({ leftContent, rightContent }) {
    return (
        <Toolbar>
            <LeftSlot>{leftContent}</LeftSlot>
            <RightSlot>{rightContent}</RightSlot>
        </Toolbar>
    );
}

PageToolbar.propTypes = {
    leftContent: PropTypes.node,
    rightContent: PropTypes.node,
};

PageToolbar.defaultProps = {
    leftContent: null,
    rightContent: null,
};

export default PageToolbar;

